const CORE = '/api/core/v1'
const ACCOUNT = '/api/v1/account'

type EndpointMap = Record<string, (...args: never[]) => string>

export const GET = {
  lists: () => `${ACCOUNT}/lists`,
  accountListsUploadStatus: (listId: string) => `${ACCOUNT}/lists/${listId}/upload-status`,
  accountUserList: () => `${ACCOUNT}/user/list`,
  datasetMetadata: (datasetId: string) => `${ACCOUNT}/dataset/${datasetId}/metadata`,
  datasetPending: (templateId: string) => `${ACCOUNT}/dataset/pending/${templateId}`,
  list: (listId: string) => `${ACCOUNT}/lists/${listId}`,
  listExport: (listId: string) => `${ACCOUNT}/lists/${listId}/export`,
  pendingDatasetGlobal: () => `${ACCOUNT}/dataset/globalPending`,
  pendingRollup: (templateId: string) => `${CORE}/pending-rollup/template/${templateId}`,
  pendingRollupGlobal: () => `${CORE}/pending-rollup/global`,
  pendingRows: (id: string) => `${ACCOUNT}/dataset/${id}/data/pending_rows`,
  reportsErrorRate: () => `${ACCOUNT}/reports/error-rate`,
  submissionsUsers: () => `${ACCOUNT}/reports/submissions/users`,
  template: (id: string) => `${ACCOUNT}/template/${id}`,
  templateErrorRate: () => `${ACCOUNT}/reports/template/error-rate`,
  templatesWithFolder: () => `${ACCOUNT}/template?with[]=folder`,
  fieldsetsWithFields: () => `${ACCOUNT}/fieldsets/populated`,
  creativeClassifications: () => `${CORE}/classifications/categories`,
  accountAuthHint: () => `/api/v1/account-auth-hint`,
  classificationRowStatus: (datasetId: string) =>
    `${CORE}/classifications/submission-requests-status/${datasetId}`,
  integrationAsset: ({ datasetId, cvId }: { datasetId: string; cvId: string }) =>
    `${CORE}/integration-assignment/asset/${datasetId}/${cvId}`,
  userIdsDraftWasSharedWIth: (draftId: string) => `${CORE}/dataset/shared-draft/${draftId}/users`,
  dailyIntegrationsReport: () => `${CORE}/integration-stream-reporting/daily`,
  taxonomyTranslations: () => `/api/taxonomy-translations`,
  taxonomyTranslation: (uuid: string) => `/api/taxonomy-translations/${uuid}`,
  taxonomyTranslationProgress: (uuid: string) => `/api/taxonomy-translations/${uuid}/progress`,
  taxonomyTranslationFieldTranslations: (uuid: string) =>
    `/api/taxonomy-translations/${uuid}/translations`,
  taxonomyTranslationReferenceFields: (uuid: string) =>
    `/api/taxonomy-translations/${uuid}/reference/fields`,
  exportTaxonomyTranslation: (uuid: string) => `/api/taxonomy-translations/${uuid}/export`,
  userActivities: () => '/api/users/activities',
  liveblocksAuth: () => '/api/liveblocks/auth',
  liveblocksPendingSuggestions: () => '/api/liveblocks/pending-comments',
  getUsers: () => '/api/users',
  campaignHealth: (integrationAssignmentId: string) =>
    `/api/campaign-health/${integrationAssignmentId}`,
  getCampaignHealthSummary: (integrationAssignmentId: string) =>
    `/api/campaign-health/${integrationAssignmentId}/summary`,
} as const satisfies EndpointMap

export const POST = {
  datasetsQuery: (id: string) => `${CORE}/datasets/${id}/query`,
  accountListsUpload: () => `${ACCOUNT}/lists/upload`,
  academy: () => `${CORE}/academy`,
  mfaCheck: () => `/api/v1/mfa/check`,
  mfaChallenge: () => `/api/v1/mfa/challenge`,
  enableMfa: () => `/api/v1/mfa/enable`,
  publicApiKey: (feature: string) => `/api/v1/user/public-api/${feature}`,
  taxonomyTranslations: () => `/api/taxonomy-translations`,
  taxonomyTranslationsFeedback: () => `/api/taxonomy-translations/feedback`,
  dataGenerationPermutations: () => `/api/data-generation/permutations`,
  dataGenerationPermutationsGenerate: () => `/api/data-generation/permutations/generate`,
  outboundOrchestrationSend: () => `/api/integrations/outbound-orchestration/send-resync-message`,
  errorCorrections: (datasetId: string) => `/api/datasets/${datasetId}/corrections`,
  liveblocksFeedback: () => `/api/liveblocks/feedback`,
  campaignHealthFeedback: () => `/api/campaign-health/feedback`,
} as const satisfies EndpointMap

export const PATCH = {
  taxonomyTranslation: (uuid: string) => `/api/taxonomy-translations/${uuid}`,
  taxonomyTranslationFieldTranslation: (uuid: string, fieldId: string) =>
    `/api/taxonomy-translations/${uuid}/translations/${fieldId}`,
  taxonomyTranslationListValueTranslation: (uuid: string, fieldId: string, index: number) =>
    `/api/taxonomy-translations/${uuid}/translations/${fieldId}/list-values/${index}`,
} as const satisfies EndpointMap

export const DELETE = {
  taxonomyTranslation: (uuid: string) => `/api/taxonomy-translations/${uuid}`,
  taxonomyTranslationFieldTranslation: (uuid: string, fieldId: string) =>
    `/api/taxonomy-translations/${uuid}/translations/${fieldId}`,
  taxonomyTranslationListValueTranslation: (uuid: string, fieldId: string, index: number) =>
    `/api/taxonomy-translations/${uuid}/translations/${fieldId}/list-values/${index}`,
} as const satisfies EndpointMap
